import $ from 'jquery'
import { TYPES_ECHANTILLONS, CONTENANTS_DEFAUT, contenants_pour_type } from '@/utils/etiquettes-echantillons'
import { closeModal } from '@/function/function.js';

export default {
    name: 'creer-analyse',
    components: {},
    props: [],
    data () {
        return {
        loading: false,
        savingCategory: false,
        categoryAnalyse: {
            nom:null
        },
        analyse: {
            abreviation: null,
            nom: null,
            categorie_id: null,
            prix: null,
            technique_utilisee:null,
            type_echantillon: null,   // LAB-002
            contenant_code: null      // LAB-002-B
        },
        types_echantillons: TYPES_ECHANTILLONS,
        contenants: CONTENANTS_DEFAUT

        }
    },

    computed: {
        categoriesAnalyses() {
            return this.$store.getters['categoriesAnalyses']
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    mounted () {
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);

        this.$store.dispatch("getAllCategoriesAnalyses");
    },

    methods: {
        // LAB-002-B : contenants proposés pour le type d'échantillon choisi
        contenants_pour(type) {
            return contenants_pour_type(type, this.contenants)
        },

        saveCategoryAnalyse: function(data){
            this.savingCategory = true;
            let err = 0;
            if (data.nom == '' || data.nom == null) {
                $('.c-error').fadeIn(1000);
                err++;

                setTimeout(() => {
                    this.savingCategory = false;
                }, 500);
            }
            if (err == 0) {
                this.$store.dispatch('saveCategorieAnalyse',data).then(
                    () => {

                    this.savingCategory = false;
                    this.$refs.closeCategoryCreateBtn.click();
                    this.successMessageCategory()
                    }
                )
            }
        },
        saveAnalyse : function(data){
            this.loading = true

            this.$store.dispatch('saveAnalyse',data).then((response) => {
                if (response.success) {
                    this.successToast("Opération effectuée avec succès")
                    this.$router.push( { name: 'listeAnalyse' });
                } else {
                    if (response.code == 401) {
                        this.warningToast("Merci de renseigner le nom de l'analyse")
                    } else if (response.code == 409) {
                        this.warningToast("Cette analyse existe déjà !")
                    } else if (response.code == 500) {
                        this.errorToast("Une erreur s'est produite ! Merci de réessayer plustard")
                    }
                }
                this.loading = false;
            }).catch(() => {
                this.errorToast("Une erreur s'est produite ! Merci de réessayer plustard")
            })
        },

        successMessageCategory: function(){
            this.$toasted.show('Une nouvelle categorie a été créée',{
            duration: 5000,
            action:[
            {
                text:'X',
                onClick:(e,toastObject)=>{
                toastObject.goAway(0);
                }
            }
            ],
            theme:'toasted-primary',
            type:'success',
            position:'top-center'
            })
        },

        cancel(){
            this.analyse.nom = null,
            this.analyse.categorie_id = null,
            this.analyse.abreviation = null
            this.analyse.prix = null
            this.analyse.type_echantillon = null
            this.analyse.contenant_code = null
        },
    
        /**
         * Close Modal
         * @param {*} selector 
        */
        closeModal(selector) 
        {
            closeModal.closeModal(selector);
        }
    }
}


